import type { ShopI18nContextValue } from '../../../i18n/provider/types'

export const PHONE_PREFIX_OPTIONS = [
  { value: '+39', label: '🇮🇹 +39', secondaryLabel: 'Italia' },
  { value: '+41', label: '🇨🇭 +41', secondaryLabel: 'Svizzera' },
  { value: '+33', label: '🇫🇷 +33', secondaryLabel: 'Francia' },
  { value: '+34', label: '🇪🇸 +34', secondaryLabel: 'Spagna' },
  { value: '+49', label: '🇩🇪 +49', secondaryLabel: 'Germania' },
  { value: '+44', label: '🇬🇧 +44', secondaryLabel: 'Regno Unito' },
  { value: '+1', label: '🇺🇸🇨🇦 +1', secondaryLabel: 'USA/Canada' },
  { value: '+351', label: '🇵🇹 +351', secondaryLabel: 'Portogallo' },
  { value: '+31', label: '🇳🇱 +31', secondaryLabel: 'Paesi Bassi' },
  { value: '+32', label: '🇧🇪 +32', secondaryLabel: 'Belgio' },
]

export const buildGenderOptions = (t: ShopI18nContextValue['t']) => [
  { value: 'female', label: t('customer.auth.gender.option.female') },
  { value: 'male', label: t('customer.auth.gender.option.male') },
  { value: 'non-binary', label: t('customer.auth.gender.option.nonBinary') },
  { value: 'prefer-not', label: t('customer.auth.gender.option.preferNot') },
]

export const buildCustomerAuthLabels = (t: ShopI18nContextValue['t']) => ({
  signupStepPersonalLabel: t('customer.auth.signupStep.personal'),
  signupStepContactLabel: t('customer.auth.signupStep.contact'),
  signupStepSecurityLabel: t('customer.auth.signupStep.security'),
  signupStepReviewLabel: t('customer.auth.signupStep.review'),
  previousStepLabel: t('customer.auth.previousStep'),
  nextStepLabel: t('customer.auth.nextStep'),
  personalDataSectionLabel: t('customer.auth.personalData'),
  phoneSectionLabel: t('customer.auth.phone'),
  contactDataSectionLabel: t('customer.auth.contactData'),
  securitySectionLabel: t('customer.auth.securityData'),
  firstNameLabel: t('customer.auth.firstName'),
  firstNamePlaceholder: t('customer.auth.firstNamePlaceholder'),
  lastNameLabel: t('customer.auth.lastName'),
  lastNamePlaceholder: t('customer.auth.lastNamePlaceholder'),
  taxCodeLabel: t('customer.auth.taxCode'),
  taxCodePlaceholder: t('customer.auth.taxCodePlaceholder'),
  genderLabel: t('customer.auth.gender'),
  genderPlaceholder: t('customer.auth.genderPlaceholder'),
  phonePrefixLabel: t('customer.auth.phonePrefix'),
  phonePrefixPlaceholder: t('customer.auth.phonePrefixPlaceholder'),
  phonePrefixSearchPlaceholder: t('customer.auth.phonePrefixSearchPlaceholder'),
  phonePrefixNoResultsLabel: t('customer.auth.phonePrefixNoResults'),
  phoneNumberLabel: t('customer.auth.phoneNumber'),
  phonePlaceholder: t('customer.auth.phonePlaceholder'),
  residentialAddressLabel: t('customer.auth.residentialAddress'),
  addressStreetLabel: t('customer.auth.addressStreet'),
  addressStreetPlaceholder: t('customer.auth.addressStreetPlaceholder'),
  addressStreetNumberLabel: t('customer.auth.addressStreetNumber'),
  addressStreetNumberPlaceholder: t('customer.auth.addressStreetNumberPlaceholder'),
  addressCityLabel: t('customer.auth.addressCity'),
  addressCityPlaceholder: t('customer.auth.addressCityPlaceholder'),
  addressPostalCodeLabel: t('customer.auth.addressPostalCode'),
  addressPostalCodePlaceholder: t('customer.auth.addressPostalCodePlaceholder'),
  addressProvinceLabel: t('customer.auth.addressProvince'),
  addressProvincePlaceholder: t('customer.auth.addressProvincePlaceholder'),
  addressCountryLabel: t('customer.auth.addressCountry'),
  addressCountryPlaceholder: t('customer.auth.addressCountryPlaceholder'),
  countrySearchPlaceholder: t('customer.auth.countrySearchPlaceholder'),
  countryNoResultsLabel: t('customer.auth.countryNoResults'),
  loginIdentifierLabel: t('customer.auth.loginIdentifier'),
  loginIdentifierPlaceholder: t('customer.auth.loginIdentifierPlaceholder'),
  loginCardTitleLabel: t('customer.auth.loginCardTitle'),
  loginCardSubtitleLabel: t('customer.auth.loginCardSubtitle'),
  loginInvalidFeedbackLabel: t('customer.auth.loginInvalidFeedback'),
  loginSecureAccessLabel: t('customer.auth.loginSecureAccess'),
  forgotPasswordLabel: t('customer.auth.forgotPassword'),
  emailLabel: t('customer.auth.email'),
  emailPlaceholder: t('customer.auth.emailPlaceholder'),
  passwordLabel: t('customer.auth.password'),
  passwordPlaceholder: t('customer.auth.passwordPlaceholder'),
  passwordShowLabel: t('customer.auth.password.show'),
  passwordHideLabel: t('customer.auth.password.hide'),
  passwordConfirmLabel: t('customer.auth.passwordConfirm'),
  passwordConfirmPlaceholder: t('customer.auth.passwordConfirmPlaceholder'),
  passwordStrengthTitleLabel: t('customer.auth.passwordStrength.title'),
  passwordStrengthWeakLabel: t('customer.auth.passwordStrength.weak'),
  passwordStrengthMediumLabel: t('customer.auth.passwordStrength.medium'),
  passwordStrengthStrongLabel: t('customer.auth.passwordStrength.strong'),
  signupCtaLabel: t('customer.auth.signupCta'),
  loginCtaLabel: t('customer.auth.loginCta'),
  requiredFieldLegendLabel: t('customer.auth.requiredLegend'),
  signupPendingSuccessLabel: t('customer.auth.signupPendingSuccess'),
  signupBotProtectionHelperLabel: t('customer.auth.turnstileHelper'),
  signupBotProtectionRequiredLabel: t('customer.auth.turnstileRequired'),
  signupReviewTitleLabel: t('customer.auth.reviewTitle'),
  signupReviewDescriptionLabel: t('customer.auth.reviewDescription'),
  signupSecurityTitleLabel: t('customer.auth.securityTitle'),
  signupSecurityDescriptionLabel: t('customer.auth.securityDescription'),
  signupSecurityHintLabel: t('customer.auth.securityHint'),
  signupFailureMessageLabel: t('customer.auth.signupFailure'),
  signupSuccessTitleLabel: t('customer.auth.signupSuccessTitle'),
  signupSuccessDescriptionLabel: t('customer.auth.signupSuccessDescription'),
  signupSuccessLoginCtaLabel: t('customer.auth.signupSuccessLoginCta'),
  signupSuccessHomeCtaLabel: t('customer.auth.signupSuccessHomeCta'),
  stepOfLabel: t('customer.auth.stepOf'),
  onStepEditLabel: t('customer.auth.reviewEdit'),
})
